<template>
  <div class="w-100">
        <div class="table-responsive  mt-3">
              <table  class="table table-shopping table-bordered table-hover table-lg mt-lg mb-0">
                <thead >
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="5%" class="text-center">Cod.</th>
                    <th width="30%" class="text-center">Nombre</th>
                    <th width="7%" class="text-center">Cantidad</th>
                    <th width="9%" class="text-center">Imp. Unit.</th>
                    <th width="5%" class="text-center">V. Unit. <br> <small>({{coin}})</small></th>
                    <th width="5%" class="text-center">V. Total <br> <small>({{coin}})</small></th>
                    <th width="5%" class="text-center">P. Unit. <br> <small>({{coin}})</small></th>
                    <th width="5%" class="text-center">P. Total <br> <small>({{coin}})</small></th>
                    <th width="5%" class="text-center">C. Unit. <br> <small>(PEN)</small></th>
                    <th width="5%" class="text-center">C. Total  <br> <small>(PEN)</small></th>
                    <th width="5%" class="text-center">CU + IGV  <br> <small>(PEN)</small></th>
                    <th width="5%" class="text-center">CT + IGV  <br> <small>(PEN)</small></th>
                    <th width="5%" class="text-center">Bultos</th>
                    <th width="5%" class="text-center"></th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in shopping_detail" :key="it">
                  <tr>
                      <td class="align-middle text-center">{{ it + 1 }}</td>
                      <td class="align-middle text-left">{{ item.code }}</td>
                      <td class="text-left">{{ item.name + (item.presentation.length == 0 ? '':' - '+item.presentation) }}</td>
                      <td class="align-middle text-center">
                        <input type="number" step="any" @change="EditDetail(it)" class="form-control text-right" v-model="item.quantity">
                      </td>
                      <td class="align-middle text-center">
                        <input type="number" step="any" @change="EditDetail(it)" class="form-control text-right" v-model="item.unit_value">
                      </td>
                      <td class="align-middle text-right">{{ item.net_unit_value }}</td>
                      <td class="align-middle text-right">{{ item.net_total_value }}</td>

                        <td class="align-middle text-right">{{ item.unit_price }}</td>
                      <td class="align-middle text-right">{{ item.total_price }}</td>

                      <td class="align-middle text-right">{{ item.unit_cost }}</td>
                      <td class="align-middle text-right">{{ item.total_cost }}</td>
                      
                      <td class="align-middle text-right">{{ item.unit_cost_final }}</td>
                      <td class="align-middle text-right">{{ item.total_cost_final }}</td>

                      <td class="align-middle text-center">
                        <input type="number" @change="EditDetail(it)" class="form-control text-right" v-model="item.package">
                      </td>
                      <td class="align-middle text-center">
                        <button type="button" @click="DeleteDetail(it)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>  
                      </td>

                  </tr>
                </tbody>
              </table>
            </div>
  </div>
</template>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.text-total{
  font-size: 14px;
  font-weight: 500;
}

.table-shopping{
  font-size: 8px !important;
}

.table-wrapper {
  overflow-x: auto;
}

.table-shopping th,
.table td {
  white-space: nowrap;
  font-size: 9px !important;
    font-weight: 500;
} 

.table-shopping th,
.table td input {

  font-size: 9px !important;

} 

</style>>
<script>
const je = require("json-encrypt");
import { mapState,mapActions } from "vuex";
import EventBus from '@/assets/js/EventBus';
import CodeToName from "@/assets/js/CodeToName";


export default {
  name: "ShoppingDetail",
  props: {
    coin: {
      type: String, // Tipo de dato esperado
      default: '' // Valor por defecto como string
    }
  },
  data() {
    return {

    };
  },
  mounted() {
    EventBus.$on('AddInputDetail', (detail) => {
      this.AddDetail(detail)
    });
    EventBus.$on('ResetInputDetail', () => {
      this.input_detail = [];
    });
    EventBus.$on('cInputDetail', (detail) => {
      this.input_detail = detail;
    });
  
  },
  methods: {
    EditDetail,
    DeleteDetail,
    NameUnitMeasure,
    ...mapActions('ShoppingV2',['mLoadEditShoppingDetail']),
    ...mapActions('ShoppingV2',['mLoadDeleteShoppingDetail']),
    
  },
  computed: {
    ...mapState('ShoppingV2',['shopping_detail']),
    
    
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let establishment = window.localStorage.getItem("id_establishment");
      establishment = JSON.parse(je.decrypt(establishment));
      return establishment;
    }
  },
};
function NameUnitMeasure(code) {
  return CodeToName.NameUnitMeasure(code);
}

function EditDetail(id_product) {
  let name = '';
  for (let index = 0; index < this.shopping_detail.length; index++) {
    const element = this.shopping_detail[index];
    if (element.id_product == id_product) {
      name = element.name + ' - ' +element.presentation;
      break;
    }
  }
  this.$notify({ group: 'alert', title: 'Sistema', text:'Se ha modificado el producto ' + name, type: 'warn'})
  this.mLoadEditShoppingDetail(id_product)
}

function DeleteDetail(id_product) {
  let name = '';
  for (let index = 0; index < this.shopping_detail.length; index++) {
    const element = this.shopping_detail[index];
    if (element.id_product == id_product) {
      name = element.name + ' - ' +element.presentation;
      break;
    }
  }
  this.$notify({ group: 'alert', title: 'Sistema', text:'Se ha eliminado el producto ' + name, type: 'warn'})
  this.mLoadDeleteShoppingDetail(id_product)
}
</script>
